import { Data } from 'common';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import React from 'react';
import { DataDisplayPanel } from './DataDisplayPanel.component';

const { Countries } = Data;

const buildAddressLines = address => {
	if (isObject(address)) {
		const country = Countries.find(
			({ countryCode }) => countryCode === address.countryCode
		);
		const isIntl = isObject(country) && country.countryCode !== 'US';
		const { city, stateProvince, postalCode, postalCodeAddon } = address;

		const cityStatePostalCode = [
			city ? `${city},` : '',
			stateProvince || '',
			postalCode && postalCodeAddon
				? `${postalCode}-${postalCodeAddon}`
				: postalCode,
		]
			.filter(str => str)
			.join(' ');

		return [
			address.name,
			address.companyName,
			address.addressLine1,
			address.addressLine2,
			address.addressLine3,
			cityStatePostalCode,

			isIntl ? country.countryName : '',
			isIntl ? address.phone : '',
			isIntl ? address.email : '',
		].filter(str => isString(str) && str !== '');
	}

	return [];
};

const AddressMockup = ({ address }) => {
	const lines = buildAddressLines(address);
	return lines.map((line, i) => (
		<React.Fragment key={i}>
			{line}
			{i < lines.length - 1 && <br />}
		</React.Fragment>
	));
};

const AddressesPanel = ({ toAddress, fromAddress, returnAddress }) => {
	const addressDetail = [
		{
			body: toAddress.addressLine1 && (
				<p>
					<AddressMockup address={toAddress} />
				</p>
			),
			className: 'shipped-to',
			dataqa: 'shipped-to',
			label: 'Shipped To:',
		},
		{
			body: isString(fromAddress?.postalCode) && fromAddress?.postalCode,
			className: 'shipped-from',
			dataqa: 'shipped-from',
			label: 'Shipped From:',
			design: true,
		},
		{
			body: returnAddress.addressLine1 && (
				<p>
					<AddressMockup address={returnAddress} />
				</p>
			),
			className: 'return-to',
			dataqa: 'return-to',
			label: 'Return To:',
		},
	];

	return (
		<>
			<div className="addresses-panel">
				{addressDetail.map((address, i) => (
					<div key={`${address.dataqa}_${i}`}>
						{address?.design && address.body && <hr />}
						{address.body && (
							<DataDisplayPanel
								label={address.label}
								body={address.body}
								dataqa={address.dataqa}
							/>
						)}
					</div>
				))}
			</div>
		</>
	);
};

export default AddressesPanel;
